import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const coverageBenefitApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'coverageBenefitApi',
  tagTypes: ['CoverageBenefit'],
  endpoints: () => ({})
})

export default coverageBenefitApi
